export {default as Boot} from './boot';
export {default as Preload} from './preload';
export {default as Menu} from './menu';
export {default as Play} from './play';
export {default as Over} from './over';
export {default as WinGame} from './win';
export {default as PreSelection} from './preselection';
export {default as SubmitForm} from './submitform';
export {default as LeaderBoard} from './leaderboard';


// WEBPACK FOOTER //
// ./js/states/index.js